<template>
    <footer>
        <template v-if="!uiStore.checkOutFlow">
            
            <div class="py-3 py-md-4 py-lg-5 content-container">

                <div class="signature fs-2 mb-5">
                    In the Press
                </div>
                <container class="mb-5">
                    <row>
                        <column :md="12" :lg="6" class="pb-5 pb-lg-0">
                            <router-link to="/press" class="box-link d-block text-center text-primary hover-text-white" style="height: 36px;" aria-label="Press">
                                <press-wsj-logo/>
                            </router-link>
                        </column>
                        <column :md="12" :lg="6" class="pb-5 pb-lg-0">
                            <router-link to="/press" class="box-link d-block text-center text-primary hover-text-white" style="height: 36px;" aria-label="Press">
                                <press-inc-logo/>
                            </router-link>
                        </column>
                        <column :md="12" :lg="6" class="pb-5 pb-md-0">
                            <router-link to="/press" class="box-link d-block text-center text-primary hover-text-white" style="height: 36px;" aria-label="Press">
                                <press-ft-logo/>
                            </router-link>
                        </column>
                        <column :md="12" :lg="6" class="pb-5 pb-md-0">
                            <router-link to="/press" class="box-link d-block text-center text-primary hover-text-white" style="height: 36px;" aria-label="Press">
                                <press-the-real-deal-logo/>
                            </router-link>
                        </column>
                    </row>
                </container>

                <divider class="d-none d-md-block" />

                <container class="mb-5">
                    <row>
                        <column :md="12">
                            <h4 class="mb-3">
                                Subscribe to our newsletter for<br />
                                <em class="text-primary">exclusive offers</em> &amp; last-minute vacations
                            </h4>
                        </column>
                        <column :md="12" class="text-start text-md-end">
                            <ui-button color="secondary" block="sm" style="min-width:250px;" @click="openNewsletterModal">
                                Subscribe
                            </ui-button>
                        </column>
                    </row>
                </container>

                <newsletter-modal v-if="showNewsletterModal" :open="newsletterModalOpen" @close="closeNewsletterModal" />

                
            </div>
            
            <divider height="sm" class="d-block d-lg-none" />

            <footer-cta-video/>

            <div class="py-3 py-md-4 py-lg-5 content-container">
                
                <h4 class="mb-5 text-center text-lg-start">Boutique <em>Collections</em></h4>

                <container class="mt-3">
                    <row>
                        <column :lg="7" class="d-block d-lg-flex align-items-center">
                            <router-link :style="(uiStore.isMobile || uiStore.isTablet) ? 'width: 150px;' : 'height:50px;'" class="d-block box-link text-primary hover-text-white mb-5 mt-3 mx-auto mx-lg-0" to="/canoe-place" aria-label="Canoe Place Inn &amp; Cottages">
                                <canoe-place-logo />
                            </router-link>
                        </column>
                        <!-- column :lg="7" class="d-block d-lg-flex align-items-center">
                            <router-link :style="(uiStore.isMobile || uiStore.isTablet) ? 'width: 150px;' : 'height:100px;'" class="d-block box-link text-primary hover-text-white mb-5 mt-3 mx-auto mx-lg-0" to="/the-drake-inn" aria-label="The Drake Inn">
                                <the-drake-inn-logo />
                            </router-link>
                        </column -->
                        
                    </row>
                </container>
            </div>
            <hr />

        </template>
        <hr v-else class="mt-0" />

        <div class="py-3 py-md-4 py-lg-5 content-container">
            <footer-navigation />
        </div>
        <hr />
        <p class="text-center p-4 small text-muted">
            &copy; 2015 - {{ year }} Marquis Rentals, LLC
        </p>
        <divider/>
    </footer>
</template>

<script type="text/javascript">


    import PressWsjLogo from '@/assets/logos/press/wsj.svg.vue';
    import PressIncLogo from '@/assets/logos/press/inc.svg.vue';
    import PressFtLogo from '@/assets/logos/press/ft.svg.vue';
    import PressTheRealDealLogo from '@/assets/logos/press/the-real-deal.svg.vue';
    import CanoePlaceLogo from '@/assets/logos/canoe-place.svg.vue';
    //import TheDrakeInnLogo from '@/assets/logos/the-drake-inn.svg.vue';

    import FooterCtaVideo from '@/components/Layout/Footer/CtaVideo.vue';
    import FooterNavigation from '@/components/Layout/Footer/Navigation.vue';
    import NewsletterModal from '@/components/Content/NewsletterModal';
    import CommonComponents from '@/components/Common.vue';

    import Analytics from '@/classes/Analytics.js';

    import { UseUIStore } from '@/store/UI.js';

    export default {

        components: {
            PressWsjLogo,
            PressIncLogo,
            PressFtLogo,
            PressTheRealDealLogo,
            NewsletterModal,
            FooterCtaVideo,
            FooterNavigation,
            CanoePlaceLogo,
            //TheDrakeInnLogo,
            ...CommonComponents,
        },
        
        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                year: (new Date().getFullYear()),

                showNewsletterModal: false,
                newsletterModalOpen: true,

                canoPlaceColor: 'beige',
            };
        },

        methods: {
            openNewsletterModal() {

                Analytics.event('SubscribeButtonClick');
                this.newsletterModalOpen = true;
                this.showNewsletterModal = true;
            },

            closeNewsletterModal() {
                this.showNewsletterModal = false;
                this.newsletterModalOpen = true;
            },
        },

        
    };

</script>
